import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import { Text } from 'react-uforms';
import { colors } from '@ch/common/const/color';
import { SpacingProps, spacingStyle } from '@ch/common/const/spacing';
import {
  form as s,
  formControlBasic,
  formControlColorVariant,
  formControlDisabledVariant,
  formControlFocusVariant,
  formControlPlaceholder,
  FormDefault,
} from '@ch/common/const/form-element';
import { FormInputProps } from './types';
import { SizeProps } from '../../../const/size';

const FormInputChild: FC<FormInputProps> = props => {
  return <Text {...props} hideError={true} />;
};

export const FormInputBasicStyles = css`
  border-radius: 0;

  /* Basic styles */
  ${formControlBasic}

  /* Color variations */
  ${formControlColorVariant()}

  /* Placeholder customization */
  ${formControlPlaceholder}

  /* Focus state */
  ${formControlFocusVariant}

  /* Disabled state */
  ${formControlDisabledVariant}
`;

export const FormInputFieldWrapStyled = styled('div')<SpacingProps>`
  position: relative;
  ${props => spacingStyle(props)};
`;

export const formInputStyles = ($size: SizeProps = 'sm') => css`
  width: 100%;
  display: block;
  ${$size &&
    `
    height: ${s.input[$size]?.height}px;
    font-size: ${s.input[$size]?.fontSize}px;
    line-height: ${s.input[$size]?.lineHeight}px;
    border-radius: ${s.input[$size]?.radius}px;
    padding: ${s.input[$size]?.padding.map(e => `${e}px`).join(' ')};
  `};
  &:focus {
    border-color: ${colors.primary};
  }
  &:disabled,
  &:not([type='color']):read-only {
    color: ${colors.grayDarker};
    background-color: ${colors.grayUltraLight};
    cursor: not-allowed;
  }
`;

export const FormInputStyled = styled(FormInputChild)<FormInputProps>`
  border: 1px solid ${({ $error }) => ($error ? colors.error : colors.grayMedium)};
  ${({ $size }) => $size && formInputStyles($size)}
`;

export const FormInputRawStyles = css`
  ${formInputStyles('md')};
`;

export const FormInputRawStyled = styled('input')`
  ${FormInputRawStyles}
`;

export const FormInputRawWrapStyled = styled('div')<SpacingProps>`
  ${props => spacingStyle(props)};
  position: relative;

  label {
    color: ${FormDefault.controlLabelColor};
    display: block;
    font-size: ${s.input['sm']?.fontSize}px;
    line-height: ${s.input['sm']?.lineHeight}px;
    font-weight: 500;
    margin-bottom: 4px;
  }
  input {
    ${FormInputRawStyles}
  }
`;
